var TorsoView = require('backbone-torso/modules/View');
var viewTemplate = require('./timeoutCountdownTemplate.hbs');

/**
  * View that for displaying a timeout countdown message
  *
  * @class TimeoutCountdownView
  * @constructor
  */
module.exports = TorsoView.extend({
  className: 'brec-dialog__content',
  template: viewTemplate
});
